import { render, staticRenderFns } from "./CustomerTrainingItemQuiz.vue?vue&type=template&id=5a67a618&scoped=true&"
import script from "./CustomerTrainingItemQuiz.vue?vue&type=script&lang=js&"
export * from "./CustomerTrainingItemQuiz.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTrainingItemQuiz.vue?vue&type=style&index=0&id=5a67a618&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a67a618",
  null
  
)

export default component.exports